import { Game } from './game/Game';

// Bootstrap. Physics (Rapier WASM) initializes before the first frame.
async function boot(): Promise<void> {
  const game = new Game();
  try {
    await game.init();
  } catch (err) {
    console.error('Panda Roll failed to start:', err);
    const root = document.getElementById('ui-root');
    if (root) {
      root.innerHTML =
        '<div class="menu"><h2>Something went wrong</h2><p>Panda Roll could not start. Check the console for details.</p></div>';
    }
  }
}

boot();

// Offline support: register the service worker in production only. Skipped on
// localhost so dev reloads always hit fresh bytes rather than the SW cache.
if (
  'serviceWorker' in navigator &&
  location.hostname !== 'localhost' &&
  location.hostname !== '127.0.0.1'
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {});
  });
}
